import type { errors } from 'google-ads-api';
import type { Describe, Infer } from 'superstruct';
import {
	any,
	array,
	boolean,
	nullable,
	number,
	object,
	optional,
	string,
} from 'superstruct';

import {
	parsableInteger,
	stringDate,
	withMessage,
} from '@adflow/shared/util-superstruct';

export const UploadGoogleAdsTemplateJobData = object({
	templateId: withMessage(parsableInteger(), 'validations:Required'),
	userId: withMessage(parsableInteger(), 'validations:Required'),
});

export const UploadGoogleAdsTemplateAccountJobReport = object({
	success: optional(
		array(
			object({
				avbId: string(),
				campaigns: optional(
					array(
						object({
							campaignName: string(),
							campaignId: string(),
							salesforceImport: boolean(),
							salesforceSyncStatus: string(),
						})
					)
				),
			})
		)
	),
	// errors.GoogleAdsError
	errors: optional(
		array(
			object({
				message: optional(nullable(string())),
				error_code: optional(any()),
				details: optional(any()),
				location: optional(
					nullable(
						object({
							field_path_elements: array(
								object({
									field_name: string(),
									index: optional(number()),
								})
							),
						}) as Describe<errors.IErrorLocation>
					)
				),
				trigger: optional(any()),
				avbId: string(),
			})
		)
	),
});

export type UploadGoogleAdsTemplateAccountJobReport = Infer<
	typeof UploadGoogleAdsTemplateAccountJobReport
>;

export const UploadGoogleAdsTemplateJobReport = object({
	templateId: number(),
	startedAt: stringDate(),
	finishedAt: stringDate(),
	results: UploadGoogleAdsTemplateAccountJobReport,
});

export type UploadGoogleAdsTemplateJobReport = Infer<
	typeof UploadGoogleAdsTemplateJobReport
>;

export type UploadGoogleAdsTemplateJobData = Infer<
	typeof UploadGoogleAdsTemplateJobData
>;
